/* Canvas Freaks — infinite scroll for collection + search grids.
   Appends the next page's .product cards into #main-collection-products on scroll,
   reusing Shopify's ?section_id= render. Reads the "Next" link from the (hidden)
   in-grid pagination each time, so facet/sort changes self-correct. The native
   pagination stays in the DOM as the "next URL" source + no-JS fallback.
   lazysizes auto-loads the appended images (no re-init needed). */
(function () {
  var grid = document.getElementById('main-collection-products');
  if (!grid || !('IntersectionObserver' in window) || !window.fetch) return;
  var sectionId = grid.getAttribute('data-id');
  var loading = false;

  var style = document.createElement('style');
  style.textContent = '#main-collection-products .pagination{display:none}'
    + '.cf-inf{flex-basis:100%;width:100%;padding:26px 0;text-align:center;min-height:1px}'
    + '.cf-inf i{display:inline-block;width:26px;height:26px;border:3px solid #e3e3e3;border-top-color:#111;border-radius:50%;animation:cfinf .8s linear infinite}'
    + '@keyframes cfinf{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);

  var sentinel = document.createElement('div');
  sentinel.className = 'cf-inf';
  grid.parentNode.insertBefore(sentinel, grid.nextSibling);

  function spin(on) { sentinel.textContent = ''; if (on) sentinel.appendChild(document.createElement('i')); }

  function nextUrl() {
    var links = grid.querySelectorAll('.pagination a[href]');
    for (var i = 0; i < links.length; i++) if (/next/i.test(links[i].textContent)) return links[i].getAttribute('href');
    return null;
  }

  function load() {
    if (loading) return;
    var url = nextUrl();
    if (!url) return;
    loading = true;
    spin(true);
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var ng = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-products');
        var pag = grid.querySelector('.pagination');
        if (ng) {
          var cards = ng.querySelectorAll('.product'), i, n;
          for (i = 0; i < cards.length; i++) { n = document.importNode(cards[i], true); if (pag) grid.insertBefore(n, pag); else grid.appendChild(n); }
          var np = ng.querySelector('.pagination');
          if (pag) { if (np) pag.replaceWith(document.importNode(np, true)); else pag.remove(); }
          else if (np) grid.appendChild(document.importNode(np, true));
          try { document.dispatchEvent(new CustomEvent('products:appended')); } catch (e) {}
        }
        loading = false;
        spin(false);
        if (nextUrl() && sentinel.getBoundingClientRect().top < window.innerHeight + 200) load();  // keep filling a tall viewport
      })
      .catch(function () { loading = false; spin(false); });
  }

  new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) load();
  }, { rootMargin: '700px 0px' }).observe(sentinel);
})();
